import { ApiClientsError } from '#pplx/frontend/api-clients/core/errors.js';
import { getQueryTimeoutMs } from '#pplx/frontend/api-clients/core/utils.js';
import { collectionsClient } from '#pplx_generated/typespec/rest/collections/client.js';
// TODO: Do we need to format the body? Clean this up.
const formatCollectionCreateEditForAPI = (body) => {
    const { accessLevel, ...restBody } = body;
    return {
        ...restBody,
        access: accessLevel,
    };
};
export const editCollectionKnowledgeSettings = async ({ collectionUuid, memoryMode, projectBrainAutoUpdateEnabled, projectBrainConnectorsEnabled, projectStatusEnabled, projectStatusSummaryInstruction, reason, }) => {
    const { data, error, response } = await collectionsClient.POST('/rest/collections/edit_collection/{collection_uuid}', reason, {
        params: {
            path: {
                collection_uuid: collectionUuid,
            },
        },
        body: {
            ...(memoryMode !== undefined ? { memory_mode: memoryMode } : {}),
            ...(projectBrainAutoUpdateEnabled !== undefined
                ? { project_brain_auto_update_enabled: projectBrainAutoUpdateEnabled }
                : {}),
            ...(projectBrainConnectorsEnabled !== undefined
                ? { project_brain_connectors_enabled: projectBrainConnectorsEnabled }
                : {}),
            ...(projectStatusEnabled !== undefined
                ? { project_status_enabled: projectStatusEnabled }
                : {}),
            ...(projectStatusSummaryInstruction !== undefined
                ? { project_status_summary_instruction: projectStatusSummaryInstruction }
                : {}),
        },
        timeoutMs: getQueryTimeoutMs(),
    });
    if (error || !data) {
        throw new ApiClientsError('API_CLIENTS_ERROR', {
            message: 'Failed to edit collection knowledge settings',
            cause: error,
            status: response.status ?? 0,
        });
    }
    return {
        memory_mode: data.memory_mode,
        project_brain_auto_update_enabled: data.project_brain_auto_update_enabled,
        project_brain_connectors_enabled: data.project_brain_connectors_enabled,
        project_status_enabled: data.project_status_enabled,
        project_status_summary_instruction: data.project_status_summary_instruction,
    };
};
export const editProjectComposerDefaults = async ({ collectionUuid, projectComposerDefaults, reason, }) => {
    const { data, error, response } = await collectionsClient.POST('/rest/collections/edit_collection/{collection_uuid}', reason, {
        params: {
            path: {
                collection_uuid: collectionUuid,
            },
        },
        body: {
            project_composer_defaults: projectComposerDefaults,
        },
        timeoutMs: getQueryTimeoutMs(),
    });
    if (error || !data?.project_composer_defaults) {
        throw new ApiClientsError('API_CLIENTS_ERROR', {
            message: 'Failed to edit project composer defaults',
            cause: error,
            status: response.status ?? 0,
        });
    }
    return data.project_composer_defaults;
};
export const editTeammateSettings = async ({ collectionUuid, teammateSettings, reason, }) => {
    const { model, plugin_dirs, reasoning_effort } = teammateSettings;
    const { data, error, response } = await collectionsClient.POST('/rest/collections/edit_collection/{collection_uuid}', reason, {
        params: { path: { collection_uuid: collectionUuid } },
        body: {
            teammate_settings: {
                model,
                plugin_dirs,
                reasoning_effort,
            },
        },
        timeoutMs: getQueryTimeoutMs(),
    });
    if (error || !data?.teammate_settings) {
        throw new ApiClientsError('API_CLIENTS_ERROR', {
            message: 'Failed to edit teammate settings',
            cause: error,
            status: response.status ?? 0,
        });
    }
    return data.teammate_settings;
};
export const editCollection = async ({ collectionUuid, changes, reason, }) => {
    const { accessLevel, ...fields } = changes;
    const bodyForAPI = {
        ...fields,
        ...(accessLevel !== undefined ? { access: accessLevel } : {}),
    };
    const { data, error, response } = await collectionsClient.POST('/rest/collections/edit_collection/{collection_uuid}', reason, {
        params: {
            path: {
                collection_uuid: collectionUuid,
            },
        },
        body: bodyForAPI,
        timeoutMs: getQueryTimeoutMs(),
    });
    if (error || !data) {
        throw new ApiClientsError('API_CLIENTS_ERROR', {
            message: 'Failed to edit collection',
            cause: error,
            status: response.status ?? 0,
        });
    }
    const result = data;
    const { access, ...restResult } = result;
    if (access !== undefined) {
        return { ...restResult, accessLevel: access };
    }
    return restResult;
};
export const createCollection = async ({ params, reason, }) => {
    const { creationContext, projectBrainAutoUpdateEnabled, projectCode, ...collectionParams } = params;
    const bodyForAPI = {
        ...formatCollectionCreateEditForAPI(collectionParams),
        ...(projectBrainAutoUpdateEnabled !== undefined
            ? { project_brain_auto_update_enabled: projectBrainAutoUpdateEnabled }
            : {}),
        ...(projectCode
            ? {
                project_code: {
                    connection_uuid: projectCode.connectionUuid,
                    installation_binding_uuid: projectCode.installationBindingUuid,
                    primary_repository_id: projectCode.primaryRepositoryId,
                    repository_ids: [...projectCode.repositoryIds],
                },
            }
            : {}),
        ...(creationContext
            ? {
                creation_context: {
                    entry_point: creationContext.entryPoint,
                    creation_method: creationContext.creationMethod,
                    creation_experience: creationContext.creationExperience,
                    creation_attempt_id: creationContext.creationAttemptId,
                },
            }
            : {}),
    };
    const { data, error, response } = await collectionsClient.POST('/rest/collections/create_collection', reason, {
        body: bodyForAPI,
        timeoutMs: getQueryTimeoutMs(),
    });
    if (error || !data) {
        throw new ApiClientsError('API_CLIENTS_ERROR', {
            message: 'Failed to create collection',
            cause: error,
            status: response.status ?? 0,
        });
    }
    return data;
};
export const deleteCollection = async ({ collectionUuid, reason, }) => {
    const { error, response } = await collectionsClient.DELETE(`/rest/collections/delete_collection/{collection_uuid}`, reason, {
        params: {
            path: {
                collection_uuid: collectionUuid,
            },
        },
        timeoutMs: getQueryTimeoutMs(),
        numRetries: 1,
    });
    if (error) {
        throw new ApiClientsError('API_CLIENTS_ERROR', {
            message: 'Failed to delete collection',
            cause: error,
            status: response.status ?? 0,
        });
    }
};
//# sourceMappingURL=collectionMutations.js.map